import { render, staticRenderFns } from "./GlobalReport.vue?vue&type=template&id=78441d12&scoped=true"
import script from "./GlobalReport.ts?vue&type=script&lang=ts&external"
export * from "./GlobalReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78441d12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78441d12')) {
      api.createRecord('78441d12', component.options)
    } else {
      api.reload('78441d12', component.options)
    }
    module.hot.accept("./GlobalReport.vue?vue&type=template&id=78441d12&scoped=true", function () {
      api.rerender('78441d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/GlobalReport/GlobalReport.vue"
export default component.exports